/**
 * @file       SSO client defaults for login start URL
 * @version    2.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or
 *             altered in anyway without expressed written permission from
 *             MindShare HDV LLC.
 */

// Empty: omit OIDC prompt so Microsoft can reuse browser SSO
const SSO_MANUAL_PROMPT = '';

export
{
    SSO_MANUAL_PROMPT
};
